import '../styles/about.css';

const About = () => {
  return (
    <div className="content-section">
      <h1 className="about-header">Hi, I&apos;m Allyson</h1>
      <p className="about-content">
        I&apos;m a <span className="about-bold-content">Software Engineer</span>{' '}
        based in NYC. My decade of marketing experience allows me to approach
        writing code through a{' '}
        <span className="about-bold-content">user-centric lens</span>. I enjoy
        working on the <span className="about-bold-content">front-end</span>,
        building user-focused experiences that translate business needs into{' '}
        <span className="about-bold-content">
          end-to-end innovative technical solutions.
        </span>
      </p>
    </div>
  );
};

export default About;
